<template lang="html">
  <div class="notice">
    <div class="cover" v-show="!active">
      <span class="edit" @click="edit">{{message.Sl127}}</span>
    </div>
    <div class="form">
      <div class="cell">
        <div class="emailTitle">{{message.Sl225}}({{emails.length}}/5):</div>
        <div class="emailList">
          <div class="cell" style="line-height: inherit" v-show="active&&emails.length<5">
             <el-input placeholder="" size="mini" v-model="emailInput">
              <el-button slot="append" @click="addEmail" icon="el-icon-plus"></el-button>
            </el-input>
          </div>
          <div class="cell email-added" v-for="(item, index) in emails" :key="item.id">
            <span :title="emails[index]">{{emails[index]}}</span>
            <i class="clear-email material-icons" v-show="active" @click="removeEmail(index)">clear</i>
          </div>
        </div>
        <div class="cell" style="text-align:center;padding-top:20px">
          <el-button style="width:80px" size='small' type="primary" v-show="active" @click="setEmail">&nbsp;{{message.Sl210}}&nbsp;</el-button>
          <el-button style="width:80px" size="small" v-show="active" @click="reset">{{message.Fl101}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        Sl131: this.$lang.ui.system.l131,
        Fl101: this.$lang.ui.form.l101,
        Sl127: this.$lang.ui.system.l127,
        Sl225: this.$lang.ui.system.l225,
        Sl210: this.$lang.ui.app.l210
      },
      active: false,
      emails: [],
      viewData: [],
      emailInput: ''
    }
  },
  mounted () {
    this.emailList()
  },
  methods: {
    view () {
      this.emalInput = ''
      this.emails = Array.from(JSON.parse(JSON.stringify(this.viewData)))
      // this.emailList()
    },
    edit () {
      this.emailInput = ''
      this.active = true
    },
    reset () {
      this.$api.getSettingsEmails(this.emails, response => {
        this.viewData = JSON.parse(JSON.stringify(this.emails))
      })
      this.emailList()
      this.view()
      this.active = false
    },
    emailList () {
      this.$api.getSettingsEmails(response => {
        this.emails = response.mail_list
        this.viewData = response.mail_list ? response.mail_list : []
        this.view()
      })
    },
    addEmail () {
      // if (this.emails.length >= 5) {
      //   this.$message({
      //     message: '新增收件人不能超过5个',
      //     type: 'warning',
      //     duration: 1200
      //   })
      //   return
      // }
      var checkEmail = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      if (!checkEmail.test(this.emailInput)) {
        this.$message({
          message: this.$lang.ui.prompt.l135,
          type: 'warning',
          duration: 1200
        })
        return
      }
      if (this._global.arrayHas(this.emails, this.emailInput)) {
        this.emailInput = ''
        return
      }
      this.emails.push(this.emailInput)
      this.viewData = JSON.parse(JSON.stringify(this.emails))
      this.emailInput = ''
    },
    setEmail () {
      this.$api.setSettingsEmails(this.emails, response => {
        this.emailList()
      })
      this.view()
      this.active = false
    },
    removeEmail (index) {
      this.emails.splice(index, 1)
    }
  }
}
</script>

<style lang="css" scoped>
.notice{
  position: relative;
  margin: 0 auto;
  padding: 25px 25px;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
}
.form {
  margin-top: 10px;
  padding-left: 10px;
  text-align: left;
  width: 100%;
  overflow: hidden;
}
.form .el-checkbox {
  margin: 4px 20px;
  width: 100%;
}
.cover {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.edit {
  position: absolute;
  cursor: pointer;
  color: #007bc5;
  top: 20px;
  right: 25px;
  display: block;
  font-size: 14px;
  font-weight: 600;
}
.cover:hover .edit {
  display: block;
}
.el-form-item {
  margin-bottom: 2px;
}
.el-input {
  position: absolute;
  left: 0;
}
.el-checkbox {
  width: 100%;
  height: 30px;
  padding-left: 40px;
  line-height: 30px;
}
.cell {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.emailTitle,
.emailList {
  float: left;
  overflow: hidden;
}
.emailTitle {
  width: 140px;
  line-height: 30px;
  padding-right: 10px;
}
.emailList {
  width: 260px;
}
.el-input {
  position: relative;
}
.emailList .cell {
  position: relative;
  margin-bottom: 5px;
  line-height: 30px;
}
.email-added {
  padding-left: 10px;
}
.email-added:hover {
  border-radius: 2px;
  background-color: #f0f0f0;
}
.clear-email {
  position: absolute;
  top: 5px;
  right: 18px;
  cursor: pointer;
  font-size: 20px;
  color: #97a8be;
}
.clear-email:hover {
  color: #d43f3a;
}
.email-added span {
  display: block;
  max-width: calc(100% - 50px);
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
